const BlockGuide = () => {
  const blockContent = [
    {
      id: 1,
      icon: "/img/featureIcons/3/1.svg",
      title: "Najtańsze kombinacje w satysfakcjonujących warunkach",
      text: `Nasze propozycje z hotelami zawierają tylko dobrze oceniane hotele z prywatną łazienką`,
      delayAnim: "100",
    },
    {
      id: 2,
      icon: "/img/featureIcons/3/2.svg",
      title: "Rezerwujesz bezpośrednio na stronach które znasz",
      text: `Nie jesteśmy pośrednikiem w rezerwacji, wszystkie rezerwacje dokonujesz bezpośrednio na stronie hotelu, linii lotniczej lub biura podróży.`,
      delayAnim: "200",
    },
    {
      id: 3,
      icon: "/img/featureIcons/3/3.svg",
      title: "Tylko bezpośrednie połączenia z Polski",
      text: `Nasz silnik wyszukiwania serwuje tylko bezpośrenie połączenia z Polski, dbając o Twój komfort i portfel`,
      delayAnim: "300",
    },
  ];
  return (
    <>
      {blockContent.map((item) => (
        <div
          className="col-lg-3 col-sm-6"
          data-aos="fade"
          data-aos-delay={item.delayAnim}
          key={item.id}
        >
          <div className="featureIcon -type-1 ">
            <div className="d-flex justify-center">
              <img src={item.icon} alt="image" className="js-lazy" />
            </div>
            <div className="text-center mt-30">
              {/* h3, not h4 - this directly follows the section's h2 ("Dlaczego tripsi?"),
                  so h4 would skip a level in the page's heading order. */}
              <h3 className="text-18 fw-500">{item.title}</h3>
              <p className="text-15 mt-10">{item.text}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BlockGuide;
